import React, { useEffect, useState } from "react";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Label,Input,Modal,ModalHeader,Button } from "reactstrap";
import Table from 'react-bootstrap/Table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

export default function Riders() {
    const[email,setEmail] = useState('');
    const[company,setCompany]=useState('');
    const[riders, setRiders] = useState([]);
    const[selectedRider, setSelectedrider] = useState('')
    const[search, setSearch] = useState('');
    const[modal, setModal] = useState(false);
    const[modal2, setModal2] = useState(false);
    const[name, setName] = useState('');
    const[phone, setPhone] = useState('');
    const[rideremail, setRideremail] = useState('');
    const[identification, setIdentification] = useState('')
    const[registration, setRegistration] = useState('')
    const[KRAPin, setKRApin] = useState('');
    const[gender, setGender] = useState('');
    const[err,setErr] = useState('')
    const[searchText,setSearchtext] = useState('Search')
    


    useEffect(() => {
                const fetchProfile = async () => {
                  try {
                    const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/profile', {
                      credentials: 'include', // to send cookies
                    });
                    const data = await res.json();
            
                    if (data.valid) {
                      setEmail(data.email)
                    } else {}
                  } catch (error) {} 
                };
            
                fetchProfile();
              }, []);
            
              //get store id
              useEffect(()=>{
               const fetchData = async()=>{
                  try{
                    const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
                    const data = await res.json();
                    setCompany(data.company)
                  }
                  catch(err){}
               }
            
               if(email){
                fetchData();
               }
               
              },[email]);
    
    
        useEffect(()=>{
            const getRiders =async()=>{
                const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getMyriders?company=${company}`);
                const data = await res.json();
                setRiders(data)
            }
    
            if(company){
                getRiders();
            }
    
        },[company])

        const getRiders =async()=>{
                const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getMyriders?company=${company}`);
                const data = await res.json();
                setRiders(data)
            }

    const exportToPdf = () => {
            const doc = new jsPDF();
        
            // Add a title to the PDF
            doc.text("Easybox_riders", 20, 10);
        
            // Extract table headers and rows from the DOM
            const table = document.getElementById("dataTable");
            const headers = Array.from(
              table.querySelectorAll("thead tr th")
            ).map((header) => header.textContent);
        
            const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
              Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
            );
        
            // Generate the PDF table
            doc.autoTable({
              head: [headers],
              body: rows,
              startY: 20,
            });
        
            // Save the PDF
            doc.save("Easybox_riders.pdf");
        }


    const getThisrider =async()=>{
        if(identification !== ''){
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getThisrider?id=${identification}`);
            const data = await res.json();
            if(data.success == true){
                setName(data.ridername);
                setRideremail(data.rideremail);
                setPhone(data.riderphone);
                setRegistration(data.registration);
                setGender(data.gender);
                setKRApin(data.KRAPin);
            }
            else{
            setErr('No rider found')
            setSearchtext('Search')
        }

        }
    }



  return (
    <div className="pagesContainer">
        <ToastContainer />
        <Breadcrumbs title="Easybox" breadcrumbItem="Riders" />
        <div className="card" style={{padding:'10px'}}>
        <div className="searchBar">
            <div className="mb-4" id="mb">
                <Label className="form-label">Search order</Label>
                <Input
                    name="search"
                    className="form-control"
                    placeholder="Search order"
                    type="text"
                    onChange={(e)=>{setSearch(e.target.value)}}
                    value={search}

                />
                
            </div>

        </div>
        <div className="">
        <Button color='info'>+ Add Rider</Button>
        <Button color='success' onClick={exportToPdf} style={{marginLeft:'2%'}}>Export</Button>
        </div>
        <hr />

        <div className="table-responsive">
        <Table striped bordered hover id="dataTable">

            <thead>
                <tr>
                    
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone</th> 
                    <th scope="col">Identification</th>  
                    <th scope="col">Reg No</th>  
                    <th scope="col">Status</th> 

                </tr>
            </thead>
            <tbody>
            {riders.map((val,index)=>{
                
                return(
                    <tr>
                        <td>{index+1}</td>
                        <td><button className="tableButton" value={val.rideremail} >{val.ridername}</button></td>
                        <td>{val.rideremail}</td>
                        <td>{val.riderphone}</td>
                        <td>{val.identification}</td>
                        <td>{val.registration}</td>
                        <td>{val.status}</td>
                        
                    </tr>
                )
            })}
            </tbody>
            </Table>
        </div>

    </div>
    </div>
  )
}
